/** 로그인 후·홈 리다이렉트 경로 */
export function getPostLoginHomePath(user?: {
  is_superuser?: boolean | null;
} | null): string {
  if (user?.is_superuser) return '/central-control';
  return '/individual-monitoring';
}

export function isSuperAdminUser(user?: {
  is_superuser?: boolean | null;
} | null): boolean {
  return Boolean(user?.is_superuser);
}
